// ANALYSIS AND CHANGES:
// This component extracts the static "Why Work With Us" section from the careers page.
// RESPONSABILIDADES:
// 1. Render the section on its own.
// 2. Keep the UI structure and content visually consistent with the original design.
// BENEFITS:
// - Reduz o tamanho e a complexidade do componente `CareersPage`.
// - Creates a component that can be reused elsewhere on the site if needed.

import {
  CheckCircleOutlined,
  DollarOutlined,
  SafetyCertificateOutlined,
  TeamOutlined,
  RiseOutlined,
  HeartOutlined,
} from "@ant-design/icons";
import { Typography } from "antd";

const { Title, Paragraph } = Typography;

const benefits = [
  {
    icon: <DollarOutlined />,
    title: "COMPETITIVE COMPENSATION",
    text: "We offer competitive salary packages, performance bonuses, and opportunities for advancement.",
  },
  {
    icon: <HeartOutlined />,
    title: "HEALTH & WELLNESS",
    text: "Comprehensive health insurance including medical, dental, and vision coverage.",
  },
  {
    icon: <RiseOutlined />,
    title: "PROFESSIONAL DEVELOPMENT",
    text: "Ongoing training programs, certification support, and opportunities to develop new skills.",
  },
  {
    icon: <CheckCircleOutlined />,
    title: "WORK-LIFE BALANCE",
    text: "Flexible schedules when possible, and an understanding that life happens outside of work.",
  },
  {
    icon: <TeamOutlined />,
    title: "TEAM ENVIRONMENT",
    text: "Join a collaborative team where your input is valued and where we celebrate successes together.",
  },
  {
    icon: <SafetyCertificateOutlined />,
    title: "SAFETY FIRST CULTURE",
    text: "Your wellbeing is our priority with comprehensive safety training, equipment, and protocols.",
  },
];

export const WhyWorkWithUsSection = () => {
  return (
    <section className="w-full py-20 bg-dark">
      <div className="container mx-auto px-4">
        <Title level={2} className="text-center">
          WHY WORK WITH US
        </Title>
        <Paragraph className="text-secondary text-center">
          At Estabrook Inc., we believe in providing a supportive environment
          where team members can thrive.
        </Paragraph>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto mt-12">
          {benefits.map((item) => (
            <div
              key={item.title}
              className="bg-charcoal p-8 flex flex-col gap-4 container-single-cut"
            >
              <div className="text-primary text-4xl">{item.icon}</div>
              <div>
                <div className="font-azonix text-white text-xl">
                  {item.title}
                </div>
                <div className="text-secondary mt-2">{item.text}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
